<template>
  <div
    class="flex overflow-hidden gap-4 items-center text-gray-500 p-2 rounded-xl"
  >
    <img
      v-if="
        ['image/png', 'image/jpg', 'image/jpeg'].includes(document.mime_type)
      "
      class="w-12 h-12 object-scale-down rounded-md"
      :src="document.urls.thumbnail"
      :alt="document.title"
    />
    <div v-else>
      <div
        class="w-12 h-12 flex items-center justify-center border border-gray-200 bg-white rounded-[6px] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]"
      >
        <FileFive class="w-6 h-6 text-gray-700" />
      </div>
    </div>

    <div class="min-w-0 flex-1">
      <p class="truncate text-gray-800 text-sm">
        {{ document.title }}
      </p>
    </div>
    <div
      class="w-9 h-9 grid place-items-center flex-shrink-0 cursor-pointer hover:text-gray-900 hover:bg-gray-50"
      @click="downloadFile(document.urls.file)"
    >
      <DownloadIcon class="w-5 h-5 text-brand-500" />
    </div>
  </div>
</template>

<script setup>
import { mobileSatisfiesVersion } from "@/Tailwind/Helpers/version";
import { useWebView } from "@/Tailwind/Mixins/useWebView";
import FileFive from "@/Tailwind/Icon/FileFive.vue";
import DownloadIcon from "@/Tailwind/Icon/DownloadIcon.vue";

defineProps({ document: Object });

const { runningInWebView, openURL } = useWebView();
const downloadFile = (url) => {
  if (!runningInWebView()) {
    window.open(url, "_blank");
    return;
  }

  if (mobileSatisfiesVersion("2.2.0")) {
    openURL(url);
    return;
  }

  // Fallback for outdated mobile apps.
  window.open(url, "_blank");
};
</script>
